/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pIndexHead.vue?vue&type=template&id=1073cfda&scoped=true"
import script from "./pIndexHead.vue?vue&type=script&lang=js"
export * from "./pIndexHead.vue?vue&type=script&lang=js"
import style0 from "./pIndexHead.vue?vue&type=style&index=0&id=1073cfda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1073cfda",
  null
  
)

export default component.exports